import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/wp-content/uploads/2022/07/f-meter.jpg")